import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { Response, Http } from '@angular/http';
import { dateToUnixTime } from '../utils';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';


export const TABLERO = {
  DASH_COSECHA: 'COSECHA',
  DASH_ACOPIOS: 'ACOPIOS',
  DASH_ENTREGA: 'ENTREGA',
  DASH_CLIENTE: 'CLIENTE'
};

@Injectable()

export class TableroNegocioService {

  constructor(private httpClient: HttpClient, private http: Http) {
  }

  public dashValues = {
    TotalNegocios: null,
    Confirmados: null,
    Productos: null,
    Cosecha: null,
    Acopio: null,
    TiposNegocio: null,
    Negocio: null,
    Clientes: null,
    Entrega: null,
    Mercados: null,
    Filter: null
  };

  dashLoaded = false;
  dashLastUpdate: any = null;

  getTotalNegocios(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios', Filter)
      .map((response: Response) => {
        this.dashValues.TotalNegocios = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.TotalNegocios;
      });
  }

  buildFilter(filter) {
    const object = {
      FilterTipo: [filter.tipo],
      FechaFrom: filter.fechaCreacion.desde !== null ? dateToUnixTime(filter.fechaCreacion.desde) : 0,
      FechaTo: filter.fechaCreacion.hasta !== null ? dateToUnixTime(filter.fechaCreacion.hasta) : 0,
      FilterAcopio: filter.acopio.map(x => x.Id),
      FilterProducto: filter.producto,
      FilterCosecha: [filter.cosechaId],
      FilterNegocio: filter.negocio,
      // si es disponible, enviar la entrega
      // si es forward enviar id 3 que corresponde a nPosiciones
      FilterEntrega: filter.negocio === 'D' || filter.negocio === null ? filter.entrega : filter.negocio === 'F' ? 3 : 4,
      FilterPosicion: filter.negocio === 'F' || filter.negocio === 'P' ? filter.entrega : null,
      QuickFilterComprometidas: filter.quickComprometidas ? true : null,
      QuickFilterOportunidades: filter.quickOportunidades ? true : null,
      QuickFilterFinalizadas: filter.quickFinalizadas ? true : null,
      ResultSize: filter.ResultSize,
      FilterZona: filter.zona,
      FilterCliente: filter.cliente.map(x => x.Id),
      FilterResponsable: filter.responsable.map(x => x.UserId),
      FilterAutorizante: filter.autorizante.map(x => x.UserId),
      MercadoId: filter.mercado,
      FuenteId: filter.fuente,
      FechaModificacion: null,
      FechaEstado: null,
    };
    if ( filter.marcaTemporal.desde !== null && filter.marcaTemporal.hasta !== null) {
      object.FechaModificacion = {
        From: filter.marcaTemporal.desde,
        To: filter.marcaTemporal.hasta
      };
    }
    if ( filter.fechaEstado.desde !== null && filter.fechaEstado.hasta !== null) {
      object.FechaEstado = {
        From: filter.fechaEstado.desde,
        To: filter.fechaEstado.hasta
      };
    }
    return object;
  }

  getDashConfirmados(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/confirmados', Filter)
      .map((response: Response) => {
        this.dashValues.Confirmados = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Confirmados;
      });
  }

  getDashProductos(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/productos', Filter)
      .map((response: Response) => {
        this.dashValues.Productos = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Productos;
      });
  }

  getDashCosecha(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/cosechas', Filter)
      .map((response: Response) => {
        this.dashValues.Cosecha = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Cosecha;
      });
  }

  getDashAcopio(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/acopios', Filter)
      .map((response: Response) => {
        this.dashValues.Acopio = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Acopio;
      });
  }

  getDashTiposNegocio(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/tipos-negocio', Filter)
      .map((response: Response) => {
        this.dashValues.TiposNegocio = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.TiposNegocio;
      });
  }

  getDashNegocio(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/tipo-entregas', Filter)
      .map((response: Response) => {
        this.dashValues.Negocio = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Negocio;
      });
  }

  getDashClientes(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/clientes', Filter)
      .map((response: Response) => {
        this.dashValues.Clientes = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Clientes;
      });
  }

  getDashEntrega(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/entregas', Filter)
      .map((response: Response) => {
        this.dashValues.Entrega = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Entrega;
      });
  }

  getDashMercados(filters) {
    const Filter = this.buildFilter(filters);
    return this.httpClient.post('/api/dashboard/negocios/mercados', Filter)
      .map((response: Response) => {
        this.dashValues.Mercados = response.json().ResponseData;
        this.checkAllLoaded();
        return this.dashValues.Mercados;
      });
  }

  checkAllLoaded() {
    this.dashLoaded = this.dashValues.TotalNegocios && this.dashValues.Confirmados && this.dashValues.Productos && this.dashValues.Cosecha && this.dashValues.Acopio && this.dashValues.TiposNegocio && this.dashValues.Negocio && this.dashValues.Clientes && this.dashValues.Entrega && this.dashValues.Mercados;
  }

  setLastUpdate() {
    this.dashLastUpdate = moment();
    this.dashValues = {
      TotalNegocios: null,
      Confirmados: null,
      Productos: null,
      Cosecha: null,
      Acopio: null,
      TiposNegocio: null,
      Negocio: null,
      Clientes: null,
      Entrega: null,
      Mercados: null,
      Filter: this.dashValues.Filter
    };
    this.dashLoaded = false;
  }

}

interface DateFilter {
  From?: Date,
  To?: Date,
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/tablero-negocios-service.ts